import * as React from "react";
import SlideButton from "../../Components/SlideButton/SlideButton";
import { getExpInYrs } from "../../Utilities/Scripts/dateCalc";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.alertOnClick = this.alertOnClick.bind(this);
  }

  alertOnClick = (e) => {
    e.preventDefault();
    alert("Stay tuned!!!");
  };

  render() {
    return (
      <div className="about" id="about">
        <div className="about-container">
          <div className="about-wrapper">
            <div className="about-header">
              <div className="about-header-title">About Me</div>
              <div className="about-header-bio">
                Passionate Coder | Avid Gamer | Total Geek
              </div>
            </div>
            <div className="about-body">
              <div className="about-image">
                <img src="/profile-image.jpg" alt="my-pic" />
              </div>
              <div className="about-details">
                <div className="about-details-left">
                  <div className="about-full-name">
                    <span className="about-entry-title">The Name I go by:</span>{" "}
                    Sunildas S
                  </div>
                  <div className="about-age">
                    <span className="about-entry-title">
                      The Day when it all began:
                    </span>{" "}
                    Wednesday, 19 June 1996
                  </div>
                </div>
                <div className="about-details-right">
                  <div className="about-address">
                    <span className="about-entry-title">
                      Base of Operations:
                    </span>{" "}
                    Palakkad, Kerala, India.
                  </div>
                </div>
              </div>
              <div className="about-description">
                I am a full-stack developer and have been primarily working in
                responsive web page development and mobile app development
                supporting cross-platform devices using latest web technologies
                for more than {getExpInYrs()} years. I keep myself entertained
                by playing video games and is an enthusiastic follower of pop
                culture, especially comics and comic-book movies.
              </div>
              <div className="about-resume">
                <SlideButton
                  targetLink="https://drive.google.com/u/0/uc?id=1YQjDdM1tD0OXpwURrygHzFEAE7r5VXNq&export=download"
                  mainText="Download Portfolio"
                  hoverText="Click Here"
                />
                <SlideButton
                  targetLink="https://drive.google.com/u/0/uc?id=16qy4xDAah3Nui9mrAloo8YiDnMS17rTd&export=download"
                  mainText="Download Resume"
                  hoverText="Click Here"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
